import User from '../models/User';

export default function canReenableSubscription(user: User): boolean {
  return user?.subscriptionStatus === 'cancelled';
}
